import { ChevronDown } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function ShopColumnHeader({
  visible,
  sortKey,
  sortDir,
  onSort,
}: {
  visible: boolean;
  sortKey?: string;
  sortDir?: 'asc' | 'desc';
  onSort?: (key: string) => void;
}) {
  const { t } = useTranslation();
  if (!visible) return null;
  const sortable = typeof onSort === 'function';
  return (
    <th
      className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider${
        sortable ? ' cursor-pointer hover:bg-gray-100' : ''
      }`}
      onClick={sortable ? () => onSort('shopName') : undefined}
    >
      <div className="flex items-center space-x-1">
        <span>{t('common.shop', 'Shop')}</span>
        {sortable && sortKey === 'shopName' && (
          <ChevronDown className={`w-4 h-4 transform ${sortDir === 'asc' ? 'rotate-180' : ''}`} />
        )}
      </div>
    </th>
  );
}

export function ShopColumnCell({
  visible,
  shopName,
}: {
  visible: boolean;
  shopName?: string | null;
}) {
  if (!visible) return null;
  return (
    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">
      {shopName?.trim() || '—'}
    </td>
  );
}
